import axios from "axios";

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");

const runtimeBackendUrl = "https://wrd-ngdi-api-wrd-test.eu.mike-cloud-test.com/api/v1";

const resolveApiUrls = (backendUrl?: string) => {
  const normalizedBackendUrl = trimTrailingSlash(
    backendUrl || window.location.origin,
  );

  if (normalizedBackendUrl.endsWith("/api/v1")) {
    const baseUrl = normalizedBackendUrl.replace(/\/v1$/, "");

    return {
      apiHost: baseUrl.replace(/\/api$/, ""),
      apiBaseUrl: baseUrl,
      apiV1BaseUrl: normalizedBackendUrl,
    };
  }

  if (normalizedBackendUrl.endsWith("/api")) {
    return {
      apiHost: normalizedBackendUrl.replace(/\/api$/, ""),
      apiBaseUrl: normalizedBackendUrl,
      apiV1BaseUrl: `${normalizedBackendUrl}/v1`,
    };
  }

  return {
    apiHost: normalizedBackendUrl,
    apiBaseUrl: `${normalizedBackendUrl}/api`,
    apiV1BaseUrl: `${normalizedBackendUrl}/api/v1`,
  };
};

export const { apiHost, apiBaseUrl, apiV1BaseUrl } =
  resolveApiUrls(runtimeBackendUrl);
export const staticDataBaseUrl = "https://ndgi.blob.core.windows.net/static-data";

const api = axios.create({
  baseURL: apiV1BaseUrl,
});

export default api;
